const getters = {
  // 获取当前选中状态下菜单的子菜单
  getMenuChildrenList: (state) => (id) => {
    return state.menuList.filter(i => i.id === id)[0].childrenList;
  }
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js